// src/components/SiteFooter.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteFooter() {
  const [winW, setWinW] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  React.useEffect(() => {
    const onResize = () => setWinW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isMobile = winW <= 640;

  return (
    <footer
      style={{
        marginTop: 40,
        background: '#0f5132',
        color: '#eaf5ee',
        padding: '24px 16px',
        overflowX: 'hidden',
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr',
          gap: 16,
          minWidth: 0,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <h5 style={{ marginTop: 0 }}>{'\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0438'}</h5>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: '1.9' }}>
            <li>
              <Link to="/terms-and-conditions" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u0423\u043c\u043e\u0432\u0438 \u0442\u0430 \u043f\u0440\u0430\u0432\u0438\u043b\u0430'}
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u041f\u043e\u043b\u0456\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0456\u0434\u0435\u043d\u0446\u0456\u0439\u043d\u043e\u0441\u0442\u0456'}
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u041f\u043e\u043b\u0456\u0442\u0438\u043a\u0430 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u044f'}
              </Link>
            </li>
          </ul>
        </div>

        <div style={{ minWidth: 0 }}>
          <h5 style={{ marginTop: 0 }}>{'\u041a\u043e\u0440\u0438\u0441\u043d\u0435'}</h5>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: '1.9' }}>
            <li>
              <Link to="/how-it-works" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u042f\u043a \u0446\u0435 \u043f\u0440\u0430\u0446\u044e\u0454'}
              </Link>
            </li>
            <li>
              <Link to="/cafes" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u0421\u043f\u0438\u0441\u043e\u043a \u0443\u0441\u0456\u0445 \u043a\u0430\u0432\u2019\u044f\u0440\u0435\u043d\u044c'}
              </Link>
            </li>
            <li>
              <Link to="/rules" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u041f\u0440\u0430\u0432\u0438\u043b\u0430 \u043e\u0431\u043c\u0456\u043d\u0443'}
              </Link>
            </li>
            <li>
              <Link to="/partners" style={{ color: '#eaf5ee', textDecoration: 'none' }}>
                {'\u0421\u0442\u0430\u0442\u0438 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u043e\u043c (\u043a\u0430\u0432\u2019\u044f\u0440\u043d\u0435\u044e)'}
              </Link>
            </li>
          </ul>
        </div>

        <div style={{ minWidth: 0, gridColumn: isMobile ? '1 / -1' : 'auto' }}>
          <h5 style={{ marginTop: 0 }}>{'\u041a\u043e\u043d\u0442\u0430\u043a\u0442\u0438'}</h5>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr', gap: 12, minWidth: 0 }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: '1.9', overflowWrap: 'anywhere' }}>
              <li>
                <a
                  href="mailto:knyhoobih@gmail.com"
                  style={{ color: '#eaf5ee', textDecoration: 'none', overflowWrap: 'anywhere' }}
                >
                  knyhoobih@gmail.com
                </a>
              </li>
              <li style={{ opacity: 0.8 }}>© {new Date().getFullYear()} {'\u041a\u043d\u0438\u0433\u043e\u043e\u0431\u0456\u0433'} · v0.1</li>
            </ul>

            <div style={{ minWidth: 0 }}>
              <a
                href="https://t.me/knyhoobih_books"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#eaf5ee',
                  textDecoration: 'underline',
                  fontWeight: 700,
                  overflowWrap: 'anywhere',
                }}
              >
                Телеграм
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
